import React from 'react';
import 'styles/farmTreeStyle.css';
import FarmTreeView from './FarmTreeView';
import OrganisationInfoBanner from './OrganisationInfoBanner';
import TreeViewControls from './TreeViewControls';

interface OrganisationTreeViewProps {
  forceReady?: boolean;
}

const OrganisationTreeView: React.FC<OrganisationTreeViewProps> = ({
  forceReady,
}) => {
  return (
    <div className="relative flex h-screen flex-col p-2">
      <OrganisationInfoBanner />

      <TreeViewControls />

      <FarmTreeView forceReady={forceReady} />
    </div>
  );
};

export default OrganisationTreeView;
